module.exports = __webpack_public_path__ + "img/symbol_9.21d4d164.png";